import { ServiceBase } from '../../../../core/services/ServiceBase'
import UserProxy from '../proxies/UserProxy'

class UserService extends ServiceBase {
  getUserType(params) {
    return this.getData(() => UserProxy.getUserType(params))
  }
  getFEComponentAuthorized(params) {
    return this.getData(() => UserProxy.getFEComponentAuthorized(params))
  }

  postLoggedIn() {
    return this.getData(() => UserProxy.postLoggedIn())
  }
}

export default new UserService()
